// Tc.js

import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import './Tc.css';

function Tc() {
  const [scholerNo, setScholerNo] = useState('');
  const [studentData, setStudentData] = useState(null);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchStudentData();
  }, []);

  const fetchStudentData = async () => {
    try {
      const response = await fetch('/student.xlsx');
      const blob = await response.blob();
      const data = await blob.arrayBuffer();
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      setStudents(sheetData);
    } catch (error) {
      console.error('Error fetching or parsing the Excel file:', error);
    }
  };

  const handleSearch = () => {
    if (scholerNo.trim() === '') {
      setError('Please enter the Scholer Number.');
      return;
    }

    setLoading(true);
    setTimeout(() => {
      const searchData = students.find(
        (item) => String(item.scholerNo).trim() === scholerNo.trim()
      );

      if (!searchData) {
        setError('Student data not found.');
        setStudentData(null);
      } else {
        setStudentData(searchData);
        setError('');
        setSuccessMessage('Student data found successfully!');
        setTimeout(() => {
          setSuccessMessage('');
        }, 3000);
      }
      setLoading(false);
    }, 1500);
  };

  // Function to print only the image in a new window
  const printImage = () => {
    if (!studentData || !studentData.tcImage) return;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Transfer Certificate</title>
          <style>
            body, html {
              margin: 0; 
              padding: 0; 
              text-align: center;
              background: #fff;
            }
            img {
              max-width: 100vw; 
              max-height: 100vh; 
              object-fit: contain;
              margin: 0 auto;
              display: block;
            }
          </style>
        </head>
        <body>
          <img src="${studentData.tcImage}" alt="Transfer Certificate" />
          <script>
            window.onload = function() {
              window.focus();
              window.print();
              window.onafterprint = function() { window.close(); }
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="container tc-container py-5">
      <h2 className="text-center mb-5 text-white">Transfer Certificate</h2>
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="search-box shadow p-4 rounded bg-white">
            <label htmlFor="scholerNo" className="form-label search-label">
              Enter Scholer Number
            </label>
            <input
              type="text"
              id="scholerNo"
              className="form-control search-input"
              placeholder="e.g. 1024"
              value={scholerNo}
              onChange={(e) => setScholerNo(e.target.value)}
            />
            {error && <div className="alert alert-danger mt-3">{error}</div>}
            {successMessage && (
              <div className="alert alert-success mt-3">{successMessage}</div>
            )}
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-primary mt-4 px-5"
                onClick={handleSearch}
                disabled={loading}
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  'Search'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {studentData && (
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8">
            <div className="card mb-3">
              <img
                src={studentData.tcImage}
                className="card-img-top"
                alt="Transfer Certificate"
                style={{ maxHeight: '800px', objectFit: 'contain', cursor: 'pointer' }}
                onClick={printImage}
                title="Click image to print"
              />
              <div className="card-body text-center">
                <h5 className="card-title">{studentData.fullName}</h5>
                <p className="card-text">Father's Name: {studentData.Father}</p>
                <p className="card-text">Mother's Name: {studentData.Mother}</p>
                <p className="card-text">Date of Birth: {studentData.dateOfBirth}</p>
                <p className="card-text">Category: {studentData.Cate}</p>
                <p className="card-text">
                  Gender: {studentData.M_F === 'M' ? 'Male' : 'Female'}
                </p>
                <p className="card-text">Scholer Number: {studentData.scholerNo}</p>
                {/* Print Button */}
                <button
                  className="btn btn-success mt-3"
                  onClick={printImage}
                  title="Print Transfer Certificate"
                >
                  Print TC
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tc;
